import {toBoolean} from "../helpers/helpers";

interface AccountsModel {
  accountId: string;
  accountCategory: string;
  active: boolean;
}

function accountsModelFactory(json: any): AccountsModel {
  json = json || {};

  return {
    accountId: json.accountId || "",
    accountCategory: json.accountCategory || "",
    active: toBoolean(json.active),
  };
}

interface OpportunitiesModel {
  opportunityId: string;
  active: boolean;
}

function opportunitiesModelFactory(json: any): OpportunitiesModel {
  json = json || {};

  return {
    opportunityId: json.opportunityId || "",
    active: toBoolean(json.active),
  };
}

export interface CustomerOpportunityGroupModel {
  customerOpportunityGroupId?: string;
  customerOpportunityGroupName?: string;
  leadEndCustomerAccountId?: string;
  opportunities?: OpportunitiesModel[];
  accounts?: AccountsModel[];
}

export function customerOpportunityGroupModelFactory(json?: any): CustomerOpportunityGroupModel {
  json = json || {};

  return {
    customerOpportunityGroupId: json.customerOpportunityGroupId || "",
    customerOpportunityGroupName: json.customerOpportunityGroupName || "",
    leadEndCustomerAccountId: json.leadEndCustomerAccountId || "",
    opportunities: Array.from(json.opportunities || [])
      .map(it => opportunitiesModelFactory(it)) as OpportunitiesModel[],
    accounts: Array.from(json.accounts || [])
      .map(it => accountsModelFactory(it)) as AccountsModel[],
  } as CustomerOpportunityGroupModel;
}
